// removed by extract-text-webpack-plugin
module.exports = {"root":"TemplateConfigurationSubHeader__root___1uvLZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateConfiguration/TemplateConfigurationSubHeader/TemplateConfigurationSubHeader.scss
// module id = 1037
// module chunks = 0